var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNav5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9986 8.5C15.9986 9.56087 15.5772 10.5783 14.827 11.3284C14.0769 12.0786 13.0595 12.5 11.9986 12.5C10.9377 12.5 9.92033 12.0786 9.17018 11.3284C8.42004 10.5783 7.99861 9.56087 7.99861 8.5M3.63183 7.90138L2.93183 16.3014C2.78145 18.1059 2.70626 19.0082 3.0113 19.7042C3.2793 20.3157 3.74364 20.8204 4.3308 21.1382C4.99908 21.5 5.90447 21.5 7.71525 21.5H16.282C18.0928 21.5 18.9981 21.5 19.6664 21.1382C20.2536 20.8204 20.7179 20.3157 20.9859 19.7042C21.291 19.0082 21.2158 18.1059 21.0654 16.3014L20.3654 7.90138C20.236 6.34875 20.1713 5.57243 19.8275 4.98486C19.5247 4.46744 19.0739 4.0526 18.5331 3.79385C17.919 3.5 17.14 3.5 15.582 3.5L8.41525 3.5C6.85724 3.5 6.07823 3.5 5.46413 3.79384C4.92336 4.0526 4.47251 4.46744 4.16974 4.98486C3.82591 5.57243 3.76122 6.34875 3.63183 7.90138Z",
    stroke: "#631517",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNav5);
export default __webpack_public_path__ + "static/media/Nav5.6390c3f001263e84e9bb50c204d246e6.svg";
export { ForwardRef as ReactComponent };